//@flow

import styled from "styled-components"
import theme from "../Theme"

const FieldHeading = styled.h3`
  font-weight: 500;
  font-size: 0.875rem;
  display: inline-block;
  margin-bottom: .25rem;
  text-transform: uppercase;
`

FieldHeading.defaultProps = { theme }

export default FieldHeading



// WEBPACK FOOTER //
// ./src/UI/Form/FieldHeading.js